import { ajaxSend } from '../../../api/api';

import {
  CancelSatisfactionRequest,
  CancelSatisfactionResponse,
  RequestAvailableSatisfactionLanguagesRequest,
  RequestAvailableSatisfactionLanguagesResponse,
} from './satisfactionTypes';

export function requestAvailableSatisfactionLanguages({
  channel,
  contactPoint,
}: RequestAvailableSatisfactionLanguagesRequest): Promise<RequestAvailableSatisfactionLanguagesResponse> {
  return ajaxSend({
    method: 'GET',
    path: '/v2/ratings/settings/languages',
    params: {
      channel,
      contact_point: contactPoint,
    },
  });
}

export function cancelSatisfaction({
  csid,
}: CancelSatisfactionRequest): Promise<CancelSatisfactionResponse> {
  return ajaxSend({
    method: 'POST',
    path: `/v2/ratings/cancel`,
    data: { csid },
  });
}
